{
  "dashboard": {
    "logoAlt": "Smart Word Labs",
    "nav": {
      "adminPortal": "管理后台",
      "enquiries": "咨询",
      "signOut": "退出登录"
    },
    "hero": {
      "adminBadge": "管理员账户",
      "parentBadge": "家长账户",
      "greeting": "你好{{name}}",
      "subtitle": "查看您家庭中每个孩子的课程、账单、进度和导师消息。",
      "addChild": "添加孩子",
      "form": {
        "childName": "孩子姓名",
        "age": "年龄",
        "save": "保存"
      }
    },
    "plan": {
      "title": "选择月度套餐",
      "description": "免费评估始终包含在内。月度套餐可解锁实时小班课程、作业反馈和 CEFR 进度报告。",
      "viewPlans": "查看套餐"
    },
    "studentMode": {
      "title": "学生模式",
      "nextLesson": "下一节课 {{datetime}} — 一键加入，无需为孩子单独登录。",
      "noLesson": "尚未安排实时课程。您的下一次小班课时间将显示在此处。",
      "joinClass": "加入课程"
    },
    "scheduling": {
      "title": "课程与排课",
      "bookAnother": "预约另一次评估",
      "lessonFallback": "课程",
      "reschedule": "改期",
      "rescheduleToast": {
        "title": "已提交改期请求",
        "description": "您的导师将通过电子邮件确认新的时间。"
      },
      "empty": {
        "title": "预约您的免费评估",
        "description": "与 Salma 老师进行 20 分钟的诊断通话，确定孩子的 CEFR 等级和学习计划。此项完全免费，并包含在每个账户中。",
        "cta": "预约免费评估"
      }
    },
    "billing": {
      "title": "账单与订阅",
      "pastDue": "您最近一次付款失败。请更新您的银行卡以保持课程正常进行。",
      "plan": "套餐",
      "noPlan": "无有效套餐",
      "status": "状态",
      "statusNone": "无",
      "accessEnds": "访问权限结束于",
      "renewsOn": "续订于",
      "childrenEnrolled": "已注册孩子数",
      "manageSubscription": "管理订阅",
      "opening": "正在打开…",
      "choosePlan": "选择套餐"
    },
    "progress": {
      "title": "进度报告",
      "cefrLevel": "CEFR 等级",
      "awaitingAssessment": "等待评估",
      "lessonsCompleted": "已完成课程数",
      "homeworkReviewed": "已批改作业数",
      "submitHomework": "提交作业"
    },
    "homeworkFeedback": {
      "title": "作业与导师反馈",
      "empty": "暂无已提交的作业。"
    },
    "messages": {
      "title": "来自导师的消息",
      "empty": "暂无消息。导师会在每次课程结束后在此发布课堂笔记。"
    },
    "toasts": {
      "childAdded": "已添加孩子资料",
      "paymentReceived": {
        "title": "已收到付款",
        "description": "正在设置您的套餐 — 这需要几秒钟。"
      },
      "portalUnavailable": "门户不可用",
      "portalError": "无法打开账单管理门户"
    }
  },
  "homework": {
    "backToDashboard": "返回控制台",
    "title": "提交作业",
    "description": "上传朗读录音和任何练习册页面。文件将私密存储，仅您的导师可见。",
    "form": {
      "lesson": "课程",
      "selectLesson": "选择一节课",
      "lessonFallback": "课程",
      "noBookings": "您需要先预约一节课才能提交作业。",
      "audioRecording": "录音",
      "worksheet": "练习册（PDF 或图片）",
      "uploading": "正在上传…",
      "submit": "提交作业"
    },
    "submissions": {
      "title": "您的提交记录",
      "audio": "音频",
      "worksheet": "练习册",
      "watchVideoFeedback": "观看导师视频反馈",
      "empty": "尚未提交任何内容。"
    },
    "errors": {
      "fileTooLarge": "{{kind}}文件必须小于 25MB",
      "chooseLesson": "请选择此作业所属的课程",
      "attachFile": "请附加录音或练习册",
      "uploadFailed": "上传失败",
      "openFileFailed": "无法打开文件"
    },
    "toasts": {
      "submitted": "作业已提交 — 已通知您的导师"
    }
  },
  "messagesPage": {
    "backToPortal": "返回门户",
    "title": "网站咨询",
    "description": "通过联系表单发送的消息。只有您可以查看这些内容。",
    "exportCsv": "导出 CSV",
    "loading": "正在加载咨询…",
    "empty": "暂无咨询。",
    "childAge": "孩子年龄 {{age}}",
    "status": {
      "handled": "已处理",
      "new": "新"
    },
    "actions": {
      "reopen": "重新打开",
      "markHandled": "标记为已处理"
    },
    "csv": {
      "headers": {
        "received": "接收时间",
        "name": "姓名",
        "email": "电子邮件",
        "whatsapp": "WhatsApp",
        "childAge": "孩子年龄",
        "subject": "主题",
        "message": "消息",
        "status": "状态"
      },
      "filename": "smart-word-labs-咨询-{{date}}"
    },
    "toasts": {
      "updateFailed": "无法更新此咨询。",
      "nothingToExport": "目前没有可导出的咨询。",
      "exported_other": "已导出 {{count}} 条咨询。"
    }
  },
  "admin": {
    "backToDashboard": "返回控制台",
    "title": "管理后台",
    "description": "Smart Word Labs 的付款、预约、支付和用户账户。",
    "tabs": {
      "payments": "付款",
      "bookings": "预约",
      "payouts": "支付",
      "users": "用户"
    },
    "table": {
      "loading": "正在加载…",
      "clearFilters": "清除筛选",
      "details": "详情",
      "view": "查看",
      "action": "操作"
    },
    "payments": {
      "searchPlaceholder": "搜索学生或导师",
      "searchAriaLabel": "按学生或导师姓名搜索付款",
      "filterAriaLabel": "按付款状态筛选",
      "filterPlaceholder": "付款状态",
      "statuses": {
        "all": "所有付款状态",
        "unpaid": "未付款",
        "paid": "已付款",
        "refunded": "已退款"
      },
      "columns": {
        "student": "学生",
        "tutor": "导师",
        "programme": "课程项目",
        "amount": "金额",
        "payment": "付款",
        "created": "创建时间"
      },
      "empty": "没有符合这些筛选条件的付款。",
      "refund": "退款",
      "confirm": {
        "title": "确定要退款吗？",
        "description": "这将通过 Stripe 向<strong>{{name}}</strong>（{{amount}}）发起实际退款，并将该预约标记为已退款。此操作无法撤销。",
        "fallbackName": "该学生",
        "cancel": "取消",
        "confirm": "确认退款"
      },
      "toasts": {
        "success": "退款已发起，该预约现已标记为已退款。",
        "error": "无法完成退款。"
      }
    },
    "bookings": {
      "status": "状态",
      "from": "起始日期",
      "to": "结束日期",
      "statuses": {
        "all": "所有状态",
        "pending": "待处理",
        "confirmed": "已确认",
        "completed": "已完成",
        "canceled": "已取消"
      },
      "columns": {
        "scheduled": "排定时间",
        "student": "学生",
        "tutor": "导师",
        "programme": "课程项目",
        "status": "状态",
        "payment": "付款"
      },
      "empty": "没有符合这些筛选条件的预约。",
      "detail": {
        "title": "预约详情",
        "description": "此课程预约的完整记录。",
        "student": "学生",
        "studentEmail": "学生邮箱",
        "tutor": "导师",
        "programme": "课程项目",
        "amount": "金额",
        "scheduled": "排定时间",
        "created": "创建时间",
        "status": "状态",
        "payment": "付款",
        "refundedAt": "退款时间",
        "meetingLink": "会议链接",
        "stripePayment": "Stripe 付款"
      }
    },
    "payouts": {
      "totalPending": "待处理支付总额",
      "filterAriaLabel": "按状态筛选支付",
      "filterPlaceholder": "状态",
      "statuses": {
        "all": "所有状态",
        "pending": "待处理",
        "paid": "已支付"
      },
      "columns": {
        "tutor": "导师",
        "amount": "金额",
        "payoutDate": "支付日期",
        "status": "状态"
      },
      "empty": "尚未记录任何支付。",
      "markAsPaid": "标记为已支付",
      "toasts": {
        "success": "支付已标记为已完成。",
        "error": "无法更新此支付记录。"
      }
    },
    "users": {
      "filterAriaLabel": "按角色筛选用户",
      "filterPlaceholder": "角色",
      "roles": {
        "all": "所有角色",
        "parent": "家长",
        "tutor": "导师",
        "admin": "管理员"
      },
      "columns": {
        "name": "姓名",
        "email": "电子邮件",
        "role": "角色",
        "joined": "加入时间"
      },
      "empty": "没有符合此筛选条件的用户。",
      "viewTutor": "查看导师",
      "tutorFallback": "导师",
      "loadingTutor": "正在加载导师详情…",
      "noTutorProfile": "没有导师资料记录。",
      "detail": {
        "hourlyRate": "时薪",
        "commission": "佣金",
        "active": "激活状态",
        "onboardingSubmitted": "已提交入职资料",
        "specialisation": "专长领域",
        "bio": "简介",
        "yes": "是",
        "no": "否"
      }
    }
  }
}
